import { render, staticRenderFns } from "./adminCommittee.vue?vue&type=template&id=06533199&scoped=true&"
import script from "./adminCommittee.vue?vue&type=script&lang=js&"
export * from "./adminCommittee.vue?vue&type=script&lang=js&"
import style0 from "./adminCommittee.vue?vue&type=style&index=0&id=06533199&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06533199",
  null
  
)

export default component.exports